import { observer } from "mobx-react";
import { useEffect, useRef, useState } from "react";
import ConfigurationStore from "../../stores/ConfigurationStore";
import { Collapse } from "antd";

const { Panel } = Collapse;

function Connection(props) {
  const [loading, setLoading] = useState(false);
  const [hubspotFields, setHubspotFields] = useState({});
  const [shopifyFields, setShopifyFields] = useState({});
  const [maps, setMaps] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const form = useRef(null);
  const [client_id, setClientId] = useState(null);

  useEffect(() => {
    ConfigurationStore.getHubspotAccounts();
    ConfigurationStore.getApiAccounts();
    ConfigurationStore.getClients();
    let id = props.match.params.id;
    if (id) {
      ConfigurationStore.getConnection(id).then((result) => {
        Object.keys(result).map((key) => {
          console.log(`result on connection edit: ${JSON.stringify(result)}`);
          if (document.getElementsByName(key).length > 0) {
            document.getElementsByName(key)[0].value = result[key];
          }
          if (key === "client_id") {
            setClientId(result[key]);
          }
        });
      });
      setEditMode(true);
    }
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData(form.current);
    let data = {};
    // let userCompany = localStorage.getItem('userCompany')
    for (var key of formData.keys()) {
      data[key] = formData.get(key);
    }

    // data["maps"] = maps;
    // if (userCompany !== 'super') {
    //    data['client'] = userCompany
    //}

    if (editMode) {
      let connection_id = props.match.params.id;
      delete data.api_id;
      delete data.hubspot_id;
      ConfigurationStore.updateConnection(connection_id, data)
        .then(() => {
          setLoading(false);
          props.history.push("/connections");
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      ConfigurationStore.createConnection(data)
        .then(() => {
          setLoading(false);
          props.history.push("/connections");
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const getHubspotFields = (value) => {
    if (value && value !== "") {
      ConfigurationStore.getHubspotFields(value).then((res) => {
        setHubspotFields(res);
      });
    }
  };

  let { apiAccounts, hubspotAccounts, clients } = ConfigurationStore;
  return (
    <div className="add-element">
      <div className="box">
        <h2>{editMode ? "Edit" : "Add"} connection</h2>
        <div className="form-block">
          <form ref={form} onSubmit={(e) => onSubmit(e)}>
            <div className="input-box">
              <label>Name</label>
              <input className="form-control" name="name" />
            </div>
            <div className="input-box">
              <label>Api Account</label>
              <select
                disabled={editMode}
                required
                name="api_id"
                className="form-control"
              >
                <option value="">Select API account</option>
                {apiAccounts &&
                  apiAccounts.map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </select>
            </div>
            <div className="input-box">
              <label>Hubspot Account</label>
              <select
                disabled={editMode}
                onChange={(e) => getHubspotFields(e.target.value)}
                name="hubspot_id"
                className="form-control"
              >
                <option value="">Select account</option>
                {hubspotAccounts &&
                  hubspotAccounts.map((a) => {
                    return (
                      <option disabled={!a.isActive} value={a._id}>
                        {a.name}
                      </option>
                    );
                  })}
              </select>
            </div>

            <div className="input-box">
              <label>Select Client</label>
              <select
                disabled={editMode}
                name="client_id"
                className="form-control"
                value={client_id}
              >
                <option value="">Select client</option>
                {clients &&
                  clients.map((c) => {
                    return <option value={c._id}>{c.name}</option>;
                  })}
              </select>
            </div>
            <div className="btn-box">
              <button
                disabled={loading}
                htmlType="submit"
                type="submit"
                className="primarybtn create-cnt-btn"
              >
                {loading
                  ? `Please wait...`
                  : `${editMode ? "Update" : "Create"} Connection`}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default observer(Connection);
